import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { NewJobService } from '../app-service/newJob.service';
import { SharedService } from '../app-service/shared.service';
import { newJob } from '../model/newJob';
import {ToastrService} from 'ngx-toastr'
import { Router } from '@angular/router';

@Component({
  selector: 'app-stop-watch',
  templateUrl: './stop-watch.component.html',
  styleUrls: ['./stop-watch.component.css'],
})

export class StopWatchComponent implements OnInit {
  httpOptions = {
    headers: new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Headers':
        'Origin,X-Requested-With,Content-Type,Accept,GET',
      'Access-Control-Allow-Methods': 'GET',
      'Content-Type': 'application/json',
    }),
  };
  playimg:string="assets/images/play.png";
  pauseimg:string="assets/images/pause.png";
  stopimg:string="assets/images/stop.png";
  backimg:string="assets/images/back.png";
  closeimg:string="assets/images/close.png";
  //starttime = this.sharedService.sharedfromNewEntrynewjobObj1.starttime;
newStartTimeforPost:string="";
endtime:string=""
starttime:string="";
Jobstarttime:any;
timeLogDetails:any
timeArray:any[]=[]
timePopover=false
showTimeArray:any
disable=false
disableothertyre=false
disableoilsupplier =false
disableSub = false
  //hi starttimer method shared services vr taku tithun tila continue vr click kelrava r call kru or
  //shared service vrun newJob objscanner cha onbj gheun starttime dispaly kru ithe
  h: any;
  m: any;
  s: any;
  interval: any;
  DisplayTime: any;
  disableFinish=false
  pause: boolean = false;
  showPauseButton:boolean;
  stopWatchObj: newJob;
  isPM: boolean = false;
     pausTime:any='00:00:00';
     resume:boolean=false;
     finalEndtime:any;
     clocktime:any;
     clockTimeInMin:any
     array:any[7]=[];
  constructor( 
    public dialogRef: MatDialogRef<StopWatchComponent>,private router: Router,private snackBar: MatSnackBar,
    private sharedService: SharedService,private newJobService:NewJobService,private toastr:ToastrService) {
    // to Disable click outside of dialog box
    dialogRef.disableClose = true;
  }
  ngOnInit() {

    console.log(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST);
    if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton == "PM" || (this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='sublet' && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.executePMP))
    {
      this.isPM = true;
    }
    
     if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='oos'
        //  || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='hanback/buyback'
         ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='breakdown'
         ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='other'
         ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='ferry')
        { 
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.other.COMMENT=='')
          {
               
            this.disableFinish=true;
            
          }
          
        } 
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='hanback/buyback'){
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.handbackbuyback.COMMENT=='')
          {
            this.disableFinish=true;
          }
        }
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='sublet')
        {
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.supplier=='' ||
          this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.invoicenumber==null ||
          this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.cost==null ||
          !this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.kilometres ||
          this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.workcarriedout=='')
          {
            this.disableSub = true;
          }
        }
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='tyre')
        {
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.supplier =='Other')
          {
            if( this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.CostOfTyre != null && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.NumberOfTyre != null)
            {
              if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.VendorName =="" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.CostOfTyre.toString() =="0" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.NumberOfTyre.toString() == '0')
              {
                this.disableothertyre = true;
              }
            }else{
              this.disableothertyre = true;
            }
          }
         else{
            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.supplier!='' && 
            this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.tyre=='')
            {
                this.disable=true;
            }
        }
        }
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='pm')
        {
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.oilfilter && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.oilsupplier =='')
          {
            this.disableoilsupplier = true;
          }
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.supplier =='Other')
          {
            if( this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.CostOfTyre != null && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.NumberOfTyreUsed != null)
            {
              if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.VendorName=='' || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.CostOfTyre.toString() == "0" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.NumberOfTyreUsed.toString() == '')
              {
                this.disableothertyre = true;
              }
            }
            else{
              this.disableothertyre = true;
            }
          }
         else{
            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.supplier!='' && 
            this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.tyre=='')
            {
            
                this.disable=true;
            }
        }
      }
    //new Entry senario we take take obj from selectfeature compo
    //console.log(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST);
    //console.log(this.sharedService.sharedfromNewEntrynewjobObj1)
    if(this.sharedService.sharedfromNewEntrynewjobObj1!=undefined)
    {
      //new Entry senarioz
        //console.log("NewEntry")
        //To display time details
        this.timeLogDetails=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray;

        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length==0 )
        {
        this.showPauseButton=true;
        this.starttime=this.sharedService.sharedfromNewEntrynewjobObj1.starttime;
        this.Jobstarttime = this.sharedService.stime;
        this.newStartTimeforPost=this.sharedService.nst;
        }
       else
       {
          //  this.showPauseButton=this.sharedService.showPauseButton
        let len=(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length)-1;
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime==='00:00:00')
          {
            this.showPauseButton=true;
          }
           else if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime!="00:00:00")
           {
               this.showPauseButton=false;
           }
         this.Jobstarttime = this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime;
         this.pausTime=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime;
         //console.log("SWC JobstartTime="+this.Jobstarttime);

      }
    }
    else
    {
      //In auto pop senario when user come back select feature after resume and do changes then when he open clock watch to stop
      //at that time he will call Jobstarttime and showPauseButton from shared service bcs this stop watch is again initialized
      //console.log("AutoPop")
      //To display time details

      let len=(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length)-1;
      if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime==="00:00:00")
      {
       // console.log("resume")
        this.showPauseButton=true
      }
      else{
        this.showPauseButton=false;
       // console.log("pause")
      }
      //this.showPauseButton=this.sharedService.showPauseButton
      this.Jobstarttime = this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime;
      this.pausTime=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime;
        console.log("SWC JobstartTime="+this.Jobstarttime);
        //Auto Pop
      this.starttime=this.sharedService.stime;
      // this.Initialstarttime = this.sharedService.stime;
      // this.Initialstarttime=new Date(this.sharedService.stime).toLocaleTimeString().toString().slice(0,-2).trim();
      // if(this.Jobstarttime.toString().length>10){
      // this.Jobstarttime = new Date(this.sharedService.stime).toLocaleTimeString().toString().slice(0,-2).trim();
      // }
  }
    //console.log("SWC startTime="+this.starttime)
    this.interval = setInterval(() => {
      this.h = ('0' + new Date().getHours()).slice(-2);
      this.m = ('0' + new Date().getMinutes()).slice(-2);
      this.s = ('0' + new Date().getSeconds()).slice(-2);
      this.DisplayTime = this.h + ':' + this.m + ':' + this.s;
    }, 1000);

      //append Starttime to timearrya
     // this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.push(this.endtime)
}
onclose(){
 
    this.newJobService.storeJobIdOnNewService(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.RepairOrderId).subscribe
    ((data:any)=>{
      // this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton=data.
      this.sharedService.postDataObjStoredOnSharedService(data.Model);
     if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='oos'
        //  || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='hanback/buyback'
         ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='breakdown'
         ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='other'
         ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='ferry')
        { 
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.other.COMMENT=='')
          {
               
            this.disableFinish=true;
            
          }
          
        } 
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='hanback/buyback'){
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.handbackbuyback.COMMENT=='')
          {
            this.disableFinish=true;
          }
        }
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='sublet')
        {
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.supplier=='' ||
          this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.invoicenumber==null ||
          this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.cost==null ||
          !this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.kilometres ||
          this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.workcarriedout=='')
          {
            this.disableSub = true;
          }
        }
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='tyre')
        {
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.supplier =='Other')
          {
            if( this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.CostOfTyre != null && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.NumberOfTyre != null)
            {
              if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.VendorName =="" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.CostOfTyre.toString() =="0" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.NumberOfTyre.toString() == '0')
              {
                this.disableothertyre = true;
              }
            }else{
              this.disableothertyre = true;
            }
          }
         else{
            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.supplier!='' && 
            this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.tyre=='')
            {
                this.disable=true;
            }
        }
        }
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='pm')
        {
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.oilfilter && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.oilsupplier =='')
          {
            this.disableoilsupplier = true;
          }
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.supplier =='Other')
          {
            if( this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.CostOfTyre != null && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.NumberOfTyreUsed != null)
            {
              if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.VendorName=='' || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.CostOfTyre.toString() == "0" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.NumberOfTyreUsed.toString() == '')
              {
                this.disableothertyre = true;
              }
            }
            else{
              this.disableothertyre = true;
            }
          }
         else{
            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.supplier!='' && 
            this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.tyre=='')
            {
            
                this.disable=true;
            }
        }
      }
    //new Entry senario we take take obj from selectfeature compo
    //console.log(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST);
    //console.log(this.sharedService.sharedfromNewEntrynewjobObj1)
    if(this.sharedService.sharedfromNewEntrynewjobObj1!=undefined)
    {
      //new Entry senarioz
        //console.log("NewEntry")
        //To display time details
        this.timeLogDetails=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray;

        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length==0 )
        {
        this.showPauseButton=true;
        this.starttime=this.sharedService.sharedfromNewEntrynewjobObj1.starttime;
        this.Jobstarttime = this.sharedService.stime;
        this.newStartTimeforPost=this.sharedService.nst;
        }
       else
       {
          //  this.showPauseButton=this.sharedService.showPauseButton
        let len=(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length)-1;
          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime==='00:00:00')
          {
            this.showPauseButton=true;
          }
           else if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime!="00:00:00")
           {
               this.showPauseButton=false;
           }
         this.Jobstarttime = this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime;
         this.pausTime=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime;
         //console.log("SWC JobstartTime="+this.Jobstarttime);

      }
    }
    else
    {
      //In auto pop senario when user come back select feature after resume and do changes then when he open clock watch to stop
      //at that time he will call Jobstarttime and showPauseButton from shared service bcs this stop watch is again initialized
      //console.log("AutoPop")
      //To display time details

      let len=(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length)-1;
      if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime==="00:00:00")
      {
       // console.log("resume")
        this.showPauseButton=true
      }
      else{
        this.showPauseButton=false;
       // console.log("pause")
      }
      //this.showPauseButton=this.sharedService.showPauseButton
      this.Jobstarttime = this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime;
      this.pausTime=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime;
        console.log("SWC JobstartTime="+this.Jobstarttime);
        //Auto Pop
      this.starttime=this.sharedService.stime;
      // this.Initialstarttime = this.sharedService.stime;
      // this.Initialstarttime=new Date(this.sharedService.stime).toLocaleTimeString().toString().slice(0,-2).trim();
      // if(this.Jobstarttime.toString().length>10){
      // this.Jobstarttime = new Date(this.sharedService.stime).toLocaleTimeString().toString().slice(0,-2).trim();
      // }
  }
    //console.log("SWC startTime="+this.starttime)
    this.interval = setInterval(() => {
      this.h = ('0' + new Date().getHours()).slice(-2);
      this.m = ('0' + new Date().getMinutes()).slice(-2);
      this.s = ('0' + new Date().getSeconds()).slice(-2);
      this.DisplayTime = this.h + ':' + this.m + ':' + this.s;
    }, 1000);

      //append Starttime to timearrya
     // this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.push(this.endtime)
  })

}
  //this.sharedService.starTimerOnContinueClick();
pauseTimer()
  {
      //console.log(this.h + ':' + this.m + ':' + this.s);
      this.pausTime=this.h + ':' + this.m + ':' + this.s;
      this.showPauseButton=false
      //this.sharedService.saveShowPauseCondition(this.showPauseButton);
      clearInterval(this.interval);
      this.pause = true;
      // this.endtime=new Date().toISOString();
        this.endtime=this.pausTime;
        //console.log("endtime="+this.endtime)
        var difference=this.getDataDiff(this.Jobstarttime,this.pausTime);
       // console.log(difference);
        this.array={SeqNo: 0,RepairOrderId: 0,starttime:this.Jobstarttime,
          endtime:this.pausTime,clocktime:difference.toString(),starttime2:null,endtime2:null}
        this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.push(this.array)
        this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.country = this.sharedService.usercountry;
      this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.state=this.sharedService.userstate;
        this.saveData();
  }
   getDataDiff(startDate:any, endDate:any) {
            let a=startDate.split(':');
            let b=endDate.split(':');
            let temp_startTime=new Date()
            let temp_endTime=new Date()
            //console.log(temp_startTime.setHours(a[0],a[1],a[2]))
            //console.log(temp_endTime.setHours(b[0],b[1],b[2]))
              temp_startTime.setHours(a[0],a[1],a[2])
              temp_endTime.setHours(b[0],b[1],b[2])

          var diff = temp_endTime.getTime() - temp_startTime.getTime();
         /// console.log(diff)
          var days = Math.floor(diff / (60 * 60 * 24 * 1000));
          var hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
          var minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
          var seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));
          var finalClocktime= hours.toString().padStart(2, "0")+":"+minutes.toString().padStart(2, "0")+":"+seconds.toString().padStart(2, "0");
          return finalClocktime;

}

resumeTimer() {
          this.showPauseButton=true
          //this.sharedService.saveShowPauseCondition(this.showPauseButton);
            this.h = ('0' + new Date().getHours()).slice(-2);
          this.m = ('0' + new Date().getMinutes()).slice(-2);
          this.s = ('0' + new Date().getSeconds()).slice(-2);
          this.pausTime="00:00:00"
          this.endtime=this.pausTime
          this.Jobstarttime=this.h + ':' + this.m + ':' + this.s;
         // console.log(this.Jobstarttime)
         // console.log(this.pausTime)
          this.array={SeqNo: 0,RepairOrderId: 0,starttime:this.Jobstarttime,endtime:this.pausTime,
            clocktime:"00:00:00",starttime2:null,endtime2:null}
          this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.push(this.array)
          this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.country = this.sharedService.usercountry;
      this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.state=this.sharedService.userstate;
          this.saveData();
          this.resume=true
     if (this.pause)
     {
          this.interval = setInterval(() => {
          this.h = ('0' + new Date().getHours()).slice(-2);
          this.m = ('0' + new Date().getMinutes()).slice(-2);
          this.s = ('0' + new Date().getSeconds()).slice(-2);
          this.resume=true;
          this.starttime=this.h + ':' + this.m + ':' + this.s;
          //this.sharedService.saveStartTime(this.Initialstarttime);
        }, 1000);
        //console.log(this.h + ':' + this.m + ':' + this.s);
     }
    this.sharedService.saveStartTime(this.Jobstarttime)
    //console.log(this.Jobstarttime)
  }
  stopButtonClick()
  {
    //console.log("STop button click")
    if(this.disableFinish)
    {
       this.snackBar.open('Please enter the comment.','close',{
          duration:5000
        });
    }
    if(this.disable){
      this.snackBar.open('Please select Tyre name','close',{
        duration:3000,
        verticalPosition:'bottom'
      });
    }
    if(this.disableoilsupplier)
    {
      this.snackBar.open('Please enter oil supplier','close',{
        duration:3000,
        verticalPosition:'bottom'
      });
    }
    if(this.disableothertyre){
      this.snackBar.open('Please enter vendor name,cost of tyre and number of tyre used','close',{
        duration:3000,
        verticalPosition:'bottom'
      });
    }
    if(this.disableSub){
      this.snackBar.open('Please enter all fields','close',{
        duration:3000,
        verticalPosition:'bottom'
      });
    }
  }
stopTimer() {
  //console.log(this.disableFinish)
  if(this.disableFinish)
  {
    
     this.snackBar.open('Please enter comment..','',{
          duration:1000,
          panelClass: 'toasrtc'
        });
  }
  else{  

      //console.log(this.h + ':' + this.m + ':' + this.s);
      this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.status="true";
      this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.country = this.sharedService.usercountry;
      this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.state=this.sharedService.userstate;
      let len=(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length)-1;
      //final time store current time
      this.finalEndtime=this.h + ':' + this.m + ':' + this.s;
      //this.array={starttime:this.Jobstarttime,endtime:this.finalEndtime,clocktime:""}
      this.endtime=this.finalEndtime.toString();
      if(!this.showPauseButton)
      {
        //Job is pause
      this.array={SeqNo: 0,RepairOrderId: 0,starttime:this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime,endtime:this.finalEndtime,clocktime:"00:00:00",starttime2:null,endtime2:null}
      this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.push(this.array)
      }
      if(this.showPauseButton)
      {
        var difference=this.getDataDiff(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime,this.finalEndtime);
        // let a=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime.split(':');
        // let b=this.finalEndtime.split(':');
        // if(a[0]>12)
        //  {
        //    a[0]=(+a[0])-12;
        //  }
        //  if(b[0]>12)
        //  {
        //    b[0]=(+b[0])-12;
        //  }
        //   let sec1=(+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
        //   let sec2=(+b[0]) * 60 * 60 + (+b[1]) * 60 + (+b[2]);
        //   let totalsec=sec2-sec1;
        //   let hours = (String(Math.floor(totalsec / 3600))).padStart(2, "0");
        //   totalsec %= 3600;
        //   let minutes = (String(Math.floor(totalsec / 60))).padStart(2, "0");
        //   let seconds = (String(totalsec % 60)).padStart(2, "0");
        //   let diffBetweenStET=hours + ":" + minutes + ":" + seconds;

       this.array={starttime:this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime,endtime:this.finalEndtime,clocktime:difference.toString()}
       this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.push(this.array)
      }

      this.saveData();
      const data = this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST;
      // let commentData = "";
      // if(data.radiobutton.toLocaleLowerCase()==='oos'
      //   ||data.radiobutton.toLocaleLowerCase()==='breakdown'
      //   ||data.radiobutton.toLocaleLowerCase()==='other'
      //   ||data.radiobutton.toLocaleLowerCase()==='ferry'
      //   ||data.radiobutton==='RECALL/WARRANTY')
      // { 
      //   commentData = data.other.COMMENT;
      // }
      // else if (data.radiobutton==='HANDBACK/BUYBACK')
      // {
      //   commentData = data.handbackbuyback.COMMENT;  
      // }
      // else if (data.radiobutton.toLocaleLowerCase()==='sublet')
      // {
      //   commentData = data.sublet.comments;
      // }
      // else if (data.radiobutton.toLocaleLowerCase()==='pm')
      // {
      //   commentData = data.pm.Comments;
      // }
      // else if (data.radiobutton.toLocaleLowerCase()==='tyre')
      // {
      //   commentData = "";
      // }
      // else
      // {
      //   commentData = "";
      // }
      const payload = {
        RepairOrderId: data.RepairOrderId,
        WWID: data.wwid,
        EmployeeName: data.employeeName,
        MVA: data.MVA,
        REGO: data.REGO,
        MODEL: data.model,
        KM: data.km,
        StartTime: data.starttime,
        EndTime: data.endtime,
        STATUS: data.status,
        RADIOBUTTON: data.radiobutton,
        Country: data.country,
        State: data.state,
        MAKE_MDL: "",
        Comment: data.pm.Comments
      };      
      if (data.radiobutton.toLocaleLowerCase()==='pm' || (data.radiobutton.toLocaleLowerCase()==='sublet' && data.sublet.executePMP))
      {
        this.newJobService.insertPWAMDSYSUpdateBatch(payload).subscribe(response => {
        console.log('Response:', response);
        });
      }
      
      this.s = '00';
      this.m = '00';
      this.h = '00';
      clearTimeout(this.interval);
      this.onCloseDialog();
      localStorage.removeItem('JobId')
      this.router.navigate(['/workCompleted']);
  }
}

onCloseDialog(): void {
  this.onclose();
    this.dialogRef.close();
  }
h1(){
  this.timeLogDetails=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray;
      for(let i=0,j=0;i<this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length;i++)
      {
        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[i].endtime != '00:00:00')
        {
          this.timeArray[j]=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[i];
          j++;
        }

      }
      //console.log(this.timeArray)
      this.showTimeArray=this.timeArray
      if(this.showTimeArray)
      {
        this.timePopover=true;
      }
}
saveData()
  {

    if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='sublet')
    {
        this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.SubletDate = new Date(this.sharedService.sharedsubdate).toLocaleDateString();
    }
    if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase() === 'tyre' )
    {
      if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.supplier != "Other"){
        this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.VendorName = "";
        this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.CostOfTyre = 0;
        
      
    }
    }
    //this.sharedService.postDataObjStoredOnSharedService(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST)
    //console.log("Post Data Obj");
     this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.wwid=parseInt(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.wwid.toString());
   //this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.starttime="2021-06-23T00:13:53.753"
    this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.starttime=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[0].starttime.toString();
    this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.endtime=this.endtime;
    //console.log(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST);
    this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST;
    let jsonObj=JSON.parse(localStorage.getItem('userDetails')!)
     this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.country = jsonObj.country;
     this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.state=jsonObj.state;
  console.log(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.starttime)
    this.newJobService.postData(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST)
    .subscribe((data:any)=>{
      //console.log(data.Success)
            if(data.Success)
            {
                this.toastr.success('Data Saved Successfully','',{
                  timeOut:3000,
                  positionClass: 'toast-bottom-full-width'
                  })
                  this.newJobService.storeJobIdOnNewService(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.RepairOrderId).subscribe
                  ((data:any)=>{
                    // this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton=data.
                    this.sharedService.postDataObjStoredOnSharedService(data.Model);
                    
                      console.log(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST)
                       if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='oos'
                          //  || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='hanback/buyback'
                           ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='breakdown'
                           ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='other'
                           ||this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='ferry')
                          { 
                            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.other.COMMENT=='')
                            {
                                 
                              this.disableFinish=true;
                              
                            }
                            
                          } 
                          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='hanback/buyback'){
                            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.handbackbuyback.COMMENT=='')
                            {
                              this.disableFinish=true;
                            }
                          }
                          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='sublet')
                          {
                            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.supplier=='' ||
                            this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.invoicenumber==null ||
                            this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.cost==null ||
                            !this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.kilometres ||
                            this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.sublet.workcarriedout=='')
                            {
                              this.disableSub = true;
                            }
                          }
                          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='tyre')
                          {
                            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.supplier =='Other')
                            {
                              if( this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.CostOfTyre != null && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.NumberOfTyre != null)
                              {
                                if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.VendorName =="" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.CostOfTyre.toString() =="0" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.NumberOfTyre.toString() == '0')
                                {
                                  this.disableothertyre = true;
                                }
                              }else{
                                this.disableothertyre = true;
                              }
                            }
                           else{
                              if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.supplier!='' && 
                              this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.tyre.tyre=='')
                              {
                                  this.disable=true;
                              }
                          }
                          }
                          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.radiobutton.toLocaleLowerCase()==='pm')
                          {
                            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.oilfilter && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.oilsupplier =='')
                            {
                              this.disableoilsupplier = true;
                            }
                            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.supplier =='Other')
                            {
                              if( this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.CostOfTyre != null && this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.NumberOfTyreUsed != null)
                              {
                                if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.VendorName=='' || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.CostOfTyre.toString() == "0" || this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.NumberOfTyreUsed.toString() == '')
                                {
                                  this.disableothertyre = true;
                                }
                              }
                              else{
                                this.disableothertyre = true;
                              }
                            }
                           else{
                              if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.supplier!='' && 
                              this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.pm.tyre=='')
                              {
                              
                                  this.disable=true;
                              }
                          }
                        }
                      //new Entry senario we take take obj from selectfeature compo
                      //console.log(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST);
                      //console.log(this.sharedService.sharedfromNewEntrynewjobObj1)
                      if(this.sharedService.sharedfromNewEntrynewjobObj1!=undefined)
                      {
                        //new Entry senarioz
                          //console.log("NewEntry")
                          //To display time details
                          this.timeLogDetails=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray;
                  
                          if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length==0 )
                          {
                          this.showPauseButton=true;
                          this.starttime=this.sharedService.sharedfromNewEntrynewjobObj1.starttime;
                          this.Jobstarttime = this.sharedService.stime;
                          this.newStartTimeforPost=this.sharedService.nst;
                          }
                         else
                         {
                            //  this.showPauseButton=this.sharedService.showPauseButton
                          let len=(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length)-1;
                            if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime==='00:00:00')
                            {
                              this.showPauseButton=true;
                            }
                             else if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime!="00:00:00")
                             {
                                 this.showPauseButton=false;
                             }
                           this.Jobstarttime = this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime;
                           this.pausTime=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime;
                           //console.log("SWC JobstartTime="+this.Jobstarttime);
                  
                        }
                      }
                      else
                      {
                        //In auto pop senario when user come back select feature after resume and do changes then when he open clock watch to stop
                        //at that time he will call Jobstarttime and showPauseButton from shared service bcs this stop watch is again initialized
                        //console.log("AutoPop")
                        //To display time details
                  
                        let len=(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.length)-1;
                        if(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime==="00:00:00")
                        {
                         // console.log("resume")
                          this.showPauseButton=true
                        }
                        else{
                          this.showPauseButton=false;
                         // console.log("pause")
                        }
                        //this.showPauseButton=this.sharedService.showPauseButton
                        this.Jobstarttime = this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].starttime;
                        this.pausTime=this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray[len].endtime;
                          console.log("SWC JobstartTime="+this.Jobstarttime);
                          //Auto Pop
                        this.starttime=this.sharedService.stime;
                        // this.Initialstarttime = this.sharedService.stime;
                        // this.Initialstarttime=new Date(this.sharedService.stime).toLocaleTimeString().toString().slice(0,-2).trim();
                        // if(this.Jobstarttime.toString().length>10){
                        // this.Jobstarttime = new Date(this.sharedService.stime).toLocaleTimeString().toString().slice(0,-2).trim();
                        // }
                    }
                      //console.log("SWC startTime="+this.starttime)
                      this.interval = setInterval(() => {
                        this.h = ('0' + new Date().getHours()).slice(-2);
                        this.m = ('0' + new Date().getMinutes()).slice(-2);
                        this.s = ('0' + new Date().getSeconds()).slice(-2);
                        this.DisplayTime = this.h + ':' + this.m + ':' + this.s;
                      }, 1000);
                  
                        //append Starttime to timearrya
                       // this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.timearray.push(this.endtime)
                    
                    console.log(this.sharedService.newJobObjectPassedFromSelectFeatureComponetforPOST.RepairOrderId)
                  })
            }
            else
            {
                  this.toastr.warning('Data not Saved','',{
                    timeOut:3000,
                    positionClass: 'toast-bottom-full-width'
                    })
            }
    },(error)=>{console.log("got error")});
  }
}
